import React, { useRef, useEffect } from "react";
import cn from "classnames";
import { Dialog as MUIDialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, TextField } from "@material-ui/core";

import { useDialogStyles } from "./Dialog.styles";

import type { IDialogProps } from "./Dialog.types";
import type { FC } from "react";

export const Dialog: FC<IDialogProps> = (props) => {
  const classes = useDialogStyles();
  const { open, onCancel, onApply, name, setName, saved, errorMessage, setMessage} = props;

  return (
    <MUIDialog
      open={open}
      classes={{ paper: classes.root }}
      onClose={onCancel}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title" className={classes.header}>
        Save bulk export settings
      </DialogTitle>
      {saved ? (
        <>
          <DialogContent className={classes.content}>
            <DialogContentText id="alert-dialog-description" className={classes.text}>
              The Bulk export settings have been successfully saved and are available under the "Saved" tab.
            </DialogContentText>
          </DialogContent>
          <DialogActions className={cn(classes.buttons, classes.center)}>
            <Button onClick={onCancel} variant="contained" color="primary" autoFocus className={cn(classes.button, classes.center)}>
              Ok
            </Button>
          </DialogActions>
        </>
      ) : (
        <>
          <DialogContent className={classes.content}>
              <TextField
                variant="outlined"
                fullWidth
                id="name"
                autoFocus
                label="Title"
                value={name}
                onChange={(e) => {
                  setName(e.target.value);
                  setMessage("")
                }}
                inputProps={{ maxLength: 64 }}
                error={!!errorMessage}
                helperText={errorMessage}
              />
          </DialogContent>
          <DialogActions className={classes.buttons}>
            <Button onClick={onApply} variant="contained" color="primary" className={classes.button}>
              Save
            </Button>
            <Button onClick={onCancel} variant="contained" color="primary" className={classes.button}>
              Cancel
            </Button>
          </DialogActions>
        </>
      )}
    </MUIDialog>
  );
};
